import { createTheme } from '@mui/material/styles'
import red from '@mui/material/colors/red'
import { esES } from '@mui/material/locale'

// 222222 - Eerie Black
// 252627 - Raising Black 373f47

const theme = createTheme({
  root: {
    '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
      outline: 'none'
    },
  },
  components: {
    // MuiFormLabel: {
    //   styleOverrides: {
    //     root: {
    //       color: '#d3d3d7',
    //     }
    //   }
    // },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        }
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // backgroundColor: '#f0eff9',
          borderColor: '#f0eff9 !important',
          borderRadius: 8,
          '& fieldset': {
            borderColor: '#a5a0c1'
          }
        }
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          /* Important property that prevents scrollbar from not showing */
          overflow: 'auto !important',
          padding: '0 !important',
          /* Important property that prevents scrollbar from not showing */
        }
      }
    },
  },
  palette: {
    primary: {
      // main: '#655dc6'
      // dark: '#4d4084',
      // light: '#4d4084',
      main: '#4d4084'
    },
    secondary: {
      dark: '#655dc6aa',
      light: '#655dc6aa',
      main: '#655dc6',
    },
    error: {
      main: red.A400,
    },
    background: {
      // default: '#f8f9fc',// '#f0f0f0',
      // default: '#fff',
      default: '#faf9fc', //'#f9f8fc'
      alternative: '#f8f9fc'
    },
    text: {
      primary: '#535461',
      secondary: '#90909a' //'#d3d3d7'
    },
    lightGreen: {
      dark: '#00ac7d',
      light: '#00c08b',
      main: '#00c08b',
      contrastText: '#fff'
    },
    lightPurple: {
      dark: '#a69fc2',
      light: '#a69fc2',
      main: '#a69fc2',
      contrastText: '#fff'
    },
    warningRed: {
      dark: '#C14953',
      light: '#C14953',
      // main: '#e94f37',
      main: '#C14953',
      contrastText: '#fff',
    }
  },
  typography: {
    fontFamily: 'Nunito, Avenir, sans-serif',
  },
}, esES)

export default theme